import { useSelector } from "react-redux";
var useSelectors = function () {
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePerson: (_a = state.Person.responsePersonById) === null || _a === void 0 ? void 0 : _a.data,
            errorPerson: state.Person.errorPersonById,
            loadingPerson: state.Person.loadingPersonById,
        });
    }), responsePerson = _a.responsePerson, errorPerson = _a.errorPerson, loadingPerson = _a.loadingPerson;
    var _b = useSelector(function (state) { return ({
        responseIdentificationType: state.IdentificationType.responseIdentificationType,
        errorIdentificationType: state.IdentificationType.errorIdentificationType,
        loadingIdentificationType: state.IdentificationType.loadingIdentificationType,
    }); }), responseIdentificationType = _b.responseIdentificationType, errorIdentificationType = _b.errorIdentificationType, loadingIdentificationType = _b.loadingIdentificationType;
    var _c = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _c.responseAllQuote, errorAllQuote = _c.errorAllQuote, loadingAllQuote = _c.loadingAllQuote;
    var _d = useSelector(function (state) { return ({
        responseBeneficiary: state.Beneficiary.responseBeneficiary,
        errorBeneficiary: state.Beneficiary.errorBeneficiary,
        loadingBeneficiary: state.Beneficiary.loadingBeneficiary,
    }); }), responseBeneficiary = _d.responseBeneficiary, errorBeneficiary = _d.errorBeneficiary, loadingBeneficiary = _d.loadingBeneficiary;
    var _e = useSelector(function (state) { return ({
        responseInsured: state.Insured.responseInsured,
        errorInsured: state.Insured.errorInsured,
        loadingInsured: state.Insured.loadingInsured,
    }); }), responseInsured = _e.responseInsured, errorInsured = _e.errorInsured, loadingInsured = _e.loadingInsured;
    var _f = useSelector(function (state) {
        var _a;
        return ({
            responseCatalogues: (_a = state.Catalogues.responseCatalogues) === null || _a === void 0 ? void 0 : _a.data,
            errorCatalogues: state.Catalogues.errorCatalogues,
            loadingCatalogues: state.Catalogues.loadingCatalogues,
        });
    }), responseCatalogues = _f.responseCatalogues, errorCatalogues = _f.errorCatalogues, loadingCatalogues = _f.loadingCatalogues;
    var _g = useSelector(function (state) { return ({
        responseCancelPolicy: state.Policy.responseCancelPolicy,
        errorCancelPolicy: state.Policy.errorCancelPolicy,
        loadingCancelPolicy: state.Policy.loadingCancelPolicy,
    }); }), responseCancelPolicy = _g.responseCancelPolicy, errorCancelPolicy = _g.errorCancelPolicy, loadingCancelPolicy = _g.loadingCancelPolicy;
    var _h = useSelector(function (state) { return ({
        responseCancelQuote: state.CancelQuote.responseCancelQuote,
        errorCancelQuote: state.CancelQuote.errorCancelQuote,
        loadingCancelQuote: state.CancelQuote.loadingCancelQuote,
    }); }), responseCancelQuote = _h.responseCancelQuote, errorCancelQuote = _h.errorCancelQuote, loadingCancelQuote = _h.loadingCancelQuote;
    return {
        responsePerson: responsePerson,
        errorPerson: errorPerson,
        loadingPerson: loadingPerson,
        responseIdentificationType: responseIdentificationType,
        errorIdentificationType: errorIdentificationType,
        loadingIdentificationType: loadingIdentificationType,
        responseAllQuote: responseAllQuote,
        errorAllQuote: errorAllQuote,
        responseBeneficiary: responseBeneficiary,
        errorBeneficiary: errorBeneficiary,
        loadingBeneficiary: loadingBeneficiary,
        responseInsured: responseInsured,
        errorInsured: errorInsured,
        loadingInsured: loadingInsured,
        responseCatalogues: responseCatalogues,
        errorCatalogues: errorCatalogues,
        loadingCatalogues: loadingCatalogues,
        responseCancelPolicy: responseCancelPolicy,
        errorCancelPolicy: errorCancelPolicy,
        loadingCancelPolicy: loadingCancelPolicy,
        responseCancelQuote: responseCancelQuote,
        errorCancelQuote: errorCancelQuote,
        loadingAllQuote: loadingAllQuote,
        loadingCancelQuote: loadingCancelQuote,
    };
};
export default useSelectors;
